import React, { useEffect, useState } from "react";
import { get, omitBy } from "lodash/fp";
import {
  Container,
  Panel,
  Pagination,
  Table,
  Footer,
  Content,
  Button,
  Form,
  Toggle,
  Col,
  SelectPicker,
  Row,
  Grid,
  Divider,
} from "rsuite";
import EditIcon from "@rsuite/icons/Edit";
import TrashIcon from "@rsuite/icons/Trash";
import CustomCell from "../../components/Elements/CustomCell";
import CustomHeaderCell from "../../components/Elements/CustomHeaderCell";
import { updateIn } from "json-immut";
import { useTranslation } from "react-i18next";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import { HelperServices } from "../../../core/services/HelperServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import { statusArr, appConstObj } from "../../../core/config/AppConstants";
import { isEmptyVal, isNotEmpty, isNotNull } from "../../../utils/helpers";
import {
  messageTypeArr,
  httpStatusArr,
} from "../../../core/config/AppConstants";
import "./Areas.css";

function Areas() {
  const { Column } = Table;
  const [loading, setLoading] = useState(false);
  const countryList = useSelector((state: any) => state.country.data);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [showFilter, setDisplayFilter] = useState(false);
  const [showAdd, setDisplayAdd] = useState(false);
  const [areaData, setAreaData] = useState<any[]>([]);
  const [areaTotal, setAreaTotal] = useState(0);

  const [rows, setRows] = useState(10);
  const [page, setPage] = useState(1);
  const [sort_by, setSortBy] = useState<any>();
  const [sort_order, setSortOrder] = useState<any>();
  const [selectedAreaId, setSelectedAreaId] = useState();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [manageCity, setManageCity] = useState<boolean>();
  const defaultSettings = UtilityServices.getLoggedInUser("settings");
  const initSearchFormData = {
    id: "",
    code: "",
    name: "",
    city: !isEmptyVal(defaultSettings["default_city"])
      ? defaultSettings["default_city"]
      : "",
    status: statusArr.active,
    pincode: "",
    is_allowed: "0,1",
    state: !isEmptyVal(defaultSettings["default_state"])
      ? defaultSettings["default_state"]
      : "",
    country: !isEmptyVal(defaultSettings["default_country"])
      ? defaultSettings["default_country"]
      : "",
  };

  const [formData, setFormData] = useState<any>(initSearchFormData);

  const [errors, setErrors] = useState<any>({});
  const { t } = useTranslation();

  async function viewArea(param: any) {
    try {
      setLoading(true);
      const response: any = await HelperServices.viewArea(param);
      let values = response.data.data;

      setFormData({
        id: values.id,
        city: values.city_id,
        country: values.city.country_id,
        state: values.city.state_id,
        name: values.area_name,
        code: values.area_code,
        pincode: values.pincode,
        status: values.status,
      });
      setLoading(false);
    } catch (error: any) {
      console.log("error ", error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setLoading(false);
    }
  }

  function getSearchParams(data?: any) {
    let paramsData = {
      ...formData,
      ...{ sort_by, sort_order },
      ...{ rows },
      ...data,
    };
    let params: any = omitBy(isEmptyVal, paramsData);
    if (data?.page) {
      params.page = data?.page;
    }

    return params;
  }

  async function getAreas(param: any) {
    try {
      if (isEmptyVal(param?.city)) return;
      setLoading(true);
      const response: any = await HelperServices.getAreas(param);
      setAreaData(get("data.data", response));
      setAreaTotal(get("data.total", response));
      setLoading(false);
    } catch (error: any) {
      console.log("error ", error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setLoading(false);
    }
  }

  const filterAreas = () => {
    let dumpError: any = [];
    let i;
    let data = { ...formData };
    let fieldsRequired: any = {
      country: "COUNTRY",
      state: "STATE",
      city: "CITY",
    };

    for (i in data) {
      if (isEmptyVal(data[i]) && i in fieldsRequired) {
        dumpError[i] =
          t("PLEASE_SELECT") + " " + t(fieldsRequired[i]).toLowerCase();
        setErrors(dumpError);
      } else {
        delete dumpError[i];
        setErrors(dumpError);
      }
    }

    if (Object.keys(dumpError).length == 0) {
      delete data.id;
      getAreas(
        getSearchParams({
          ...data,
        })
      );
    }
  };

  const handleFormChanges = (data: any) => {
    if (data.path == "status") {
      if (data.value) {
        data.value = 1;
      } else {
        data.value = 0;
      }
    }

    let form = updateIn(formData, [data.path], data.value);
    setFormData(form);
  };
  const saveArea = async () => {
    try {
      let dumpError: any = [];
      let i;
      let response: any = {};
      let fieldsConst: any = {
        name: "AREA_NAME",
        code: "AREA_CODE",
        pincode: "PINCODE",
        city: "CITY",
      };

      for (i in formData) {
        if (formData[i] == "" && i != "id" && i != "status") {
          if (i == "name" || i == "code") {
            dumpError[i] = t("REQUIRED", {
              field: t(fieldsConst[i]).toLowerCase(),
            });
          } else {
            dumpError[i] =
              t("PLEASE_SELECT") + " " + t(fieldsConst[i]).toLowerCase();
          }
          setErrors(dumpError);
        } else {
          delete dumpError[i];
          setErrors(dumpError);
        }
      }

      if (Object.keys(dumpError).length == 0) {
        setLoading(true);
        let params = {
          area_name: formData.name,
          area_code: formData.code,
          city_id: formData.city,
          area_type: "standard",
          pincode: formData.pincode,
          status: formData.status,
          id: formData.id,
        };

        if (params.id == "") {
          response = await HelperServices.addArea(params);
        } else {
          response = await HelperServices.updateArea(params);
        }

        UtilityServices.showToaster({
          message: response?.data?.message,
        });
        setFormData({
          ...initSearchFormData,
          ...{
            country: formData.country,
            state: formData.state,
            city: formData.city,
          },
        });
        setPage(1);

        getAreas(
          getSearchParams({
            ...initSearchFormData,
            ...{
              country: formData.country,
              state: formData.state,
              city: formData.city,
            },
          })
        );
      }

      setLoading(false);
    } catch (error: any) {
      if (formData.id == "") {
        UtilityServices.showToaster({
          message: error?.message,
          type: messageTypeArr.error,
        });
      } else {
        UtilityServices.showToaster({
          message: error?.message,
          type: messageTypeArr.error,
        });
      }
      setLoading(false);
    }
  };

  const editArea = async (values: any) => {
    setDisplayAdd(true);
    setDisplayFilter(false);
    viewArea(values.id);
  };

  const deleteArea = async (id: any) => {
    try {
      setLoading(true);
      const response: any = await HelperServices.deleteArea({ id: id });
      UtilityServices.showToaster({
        message: response?.data?.message,
      });

      getAreas(
        getSearchParams({
          ...initSearchFormData,
          ...{
            city: formData.city,
            page: 1,
            rows: appConstObj.record_per_page,
          },
        })
      );
      setLoading(false);
    } catch (error: any) {
      console.log("error ", error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setLoading(false);
    }
  };

  function onPageChange(page: number) {
    setPage(page);
    delete formData.id;
    getAreas(
      getSearchParams({
        page: page,
        sort_by: sort_by,
        sort_order: sort_order,
        rows: rows,
      })
    );
  }

  function onSortChange(dataKey: any, sortType: any) {
    setPage(1);
    setSortBy(dataKey);
    setSortOrder(sortType);

    getAreas(
      getSearchParams({
        page: 1,
        sort_by: dataKey,
        sort_order: sortType,
        rows: rows,
      })
    );
  }

  const handleChangeRows = (rows: any) => {
    setRows(rows);
    setPage(1);
    getAreas(
      getSearchParams({
        page: 1,
        sort_by: sort_by,
        sort_order: sort_order,
        rows: rows,
      })
    );
  };

  const toggleFilterOptions = () => {
    setDisplayFilter((value) => !value);
  };

  const toggleadAddOptions = () => {
    setDisplayAdd((value) => !value);
  };

  function clearSearch() {
    setFormData(initSearchFormData);
    setSortBy(null);
    setSortOrder(null);
    setPage(1);
    setRows(appConstObj.record_per_page);
    getAreas(
      getSearchParams({
        ...initSearchFormData,
        ...{
          page: 1,
          rows: appConstObj.record_per_page,
        },
      })
    );

    loadUserDefaultSettings();
  }

  const cancelAction = async () => {
    setErrors({});
    setDisplayFilter(false);
    setDisplayAdd(false);
  };

  async function init() {
    try {
      loadUserDefaultSettings();
    } catch (error: any) {
      console.log("error ", error);
    }
  }
  useEffect(() => {
    init();
    getAreas(
      getSearchParams({
        ...initSearchFormData,
        ...{
          page: 1,
          rows: appConstObj.record_per_page,
        },
      })
    );
  }, []);

  function loadUserDefaultSettings() {
    setLoading(true);

    let obj = { ...initSearchFormData };
    if (!isEmptyVal(defaultSettings["default_country"])) {
      obj["country"] = parseInt(defaultSettings["default_country"]);
    }
    if (!isEmptyVal(defaultSettings["default_state"])) {
      obj["state"] = parseInt(defaultSettings["default_state"]);
    }
    if (!isEmptyVal(defaultSettings["default_city"])) {
      obj["city"] = parseInt(defaultSettings["default_city"]);
    }
    setFormData({ ...obj });
    preSelectFields(obj);
    setLoading(false);
  }

  async function preSelectFields(obj: any) {
    if (obj.country) {
      handleCountryChange(obj.country);
    }
    if (obj.state) {
      handleStateChange(obj.state);
    }
  }

  async function handleCountryChange(countryId: number) {
    try {
      const stateRes = await HelperServices.getAllValidStates({
        country: countryId,
      });
      setStateList(get("data.data", stateRes));
      resetSelectionFor("state");
      handleFormChanges({ path: "country", value: countryId });
    } catch (error) {
      console.log(error);
    }
  }

  async function handleStateChange(stateId: number) {
    try {
      const res = await HelperServices.getAllValidCities({ state: stateId });
      setCityList(res.data.data);
      resetSelectionFor("city");
      handleFormChanges({ path: "state", value: stateId });
    } catch (error) {
      console.log(error);
    }
  }

  function resetSelectionFor(resetFor: string) {
    let resetData: Object = {};
    switch (resetFor) {
      case "country":
        resetData = {
          country: "",
          state: "",
          city: "",
        };
        setStateList([]);
        setCityList([]);
        break;
      case "state":
        resetData = {
          state: "",
          city: "",
        };
        setCityList([]);
        break;
      case "city":
        resetData = {
          city: "",
        };
        break;
    }
    let newFormData = {
      ...formData,
      ...resetData,
    };
    setFormData(newFormData);
  }

  return (
    <div className="users cntry">
      <Container className="container">
        <Panel className="pd-0">
          <Grid fluid>
            <Row className="show-grid mb-2">
              <Col md={12}>
                <h4>{t("AREAS")}</h4>
              </Col>
              <Col md={11} mdPush={9}>
                <Button
                  appearance="default"
                  size="sm"
                  onClick={toggleFilterOptions}
                  disabled={showAdd}
                >
                  {t("FILTER")}
                </Button>
                &nbsp;
                <Button
                  appearance="primary"
                  size="sm"
                  onClick={toggleadAddOptions}
                  disabled={showFilter}
                >
                  {t("ADD")}
                </Button>
              </Col>
            </Row>
          </Grid>
          {showFilter || showAdd ? (
            <Form formValue={formData}>
              <div className="col-md-12 area-form-div content pl-0 pb-0 mb-2">
                <div className="row">
                  <div className="col-md-6 d-flex space-between">
                    <Form.Group controlId="name">
                      <Form.ControlLabel>{t("NAME")}</Form.ControlLabel>
                      <Form.Control
                        name="name"
                        className={
                          errors["name"]
                            ? "form-control is-invalid mb-0"
                            : "form-control  mb-0"
                        }
                        onChange={(v: any) =>
                          handleFormChanges({ path: "name", value: v })
                        }
                      />
                      <span className="text-danger">{errors["name"]}</span>
                    </Form.Group>

                    <Form.Group controlId="country">
                      <Form.ControlLabel>{t("Country")}</Form.ControlLabel>
                      <SelectPicker
                        data={countryList}
                        valueKey="id"
                        labelKey="country_name"
                        onSelect={(value, item) => {
                          handleCountryChange(value);
                        }}
                        onClean={(e: any) => {
                          resetSelectionFor("country");
                        }}
                        name="country"
                        className={
                          errors["country"]
                            ? "form-select is-invalid  mb-0"
                            : "form-select  mb-0"
                        }
                        value={formData?.country}
                      />
                      <span className="text-danger">{errors["country"]}</span>
                    </Form.Group>
                    <Form.Group controlId="city" className="mb-3">
                      <Form.ControlLabel>{t("CITY")}</Form.ControlLabel>
                      <SelectPicker
                        data={cityList}
                        valueKey="id"
                        labelKey="city_name"
                        onSelect={(value, item) => {
                          handleFormChanges({ path: "city", value });
                        }}
                        onClean={(e: any) => {
                          resetSelectionFor("city");
                        }}
                        name="city"
                        className={
                          errors["city"]
                            ? "form-select is-invalid"
                            : "form-select"
                        }
                        value={formData?.city}
                      />
                      <span className="text-danger">{errors["city"]}</span>
                    </Form.Group>
                  </div>
                  <div className="col-md-6 d-flex space-between">
                    <Form.Group controlId="code">
                      <Form.ControlLabel>{t("CODE")}</Form.ControlLabel>
                      <Form.Control
                        name="code"
                        className={
                          errors["code"]
                            ? "form-control is-invalid  mb-0"
                            : "form-control  mb-0"
                        }
                        onChange={(v: any) =>
                          handleFormChanges({ path: "code", value: v })
                        }
                      />
                      <span className="text-danger">{errors["code"]}</span>
                    </Form.Group>
                    <Form.Group controlId="state">
                      <Form.ControlLabel>{t("STATE")}</Form.ControlLabel>
                      <SelectPicker
                        data={stateList}
                        valueKey="id"
                        labelKey="state_name"
                        onSelect={(value, item) => {
                          handleStateChange(value);
                        }}
                        onClean={(e: any) => {
                          resetSelectionFor("state");
                        }}
                        name="state"
                        className={
                          errors["state"]
                            ? "form-select  is-invalid  mb-0"
                            : "form-select  mb-0"
                        }
                        value={formData?.state}
                      />
                      <span className="text-danger">{errors["state"]}</span>
                    </Form.Group>
                    <Form.Group controlId="pincode" className="mb-3">
                      <Form.ControlLabel>{t("PINCODE")}</Form.ControlLabel>
                      <Form.Control
                        name="pincode"
                        className={
                          errors["pincode"]
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={(v: any) =>
                          handleFormChanges({ path: "pincode", value: v })
                        }
                      />
                      <span className="text-danger">{errors["pincode"]}</span>
                    </Form.Group>
                  </div>
                </div>
                <Col md={5}>
                  <Form.Group>
                    {t("STATUS")}:{" "}
                    <Form.Control
                      name="status"
                      accepter={Toggle}
                      checked={formData.status}
                      onChange={(v: any) =>
                        handleFormChanges({ path: "status", value: v })
                      }
                    />
                  </Form.Group>
                </Col>
                <div className="mt-2 mb-2 form-btn create-action d-flex flex-end">
                  {showFilter ? (
                    <React.Fragment>
                      <Button
                        className="rs-btn-deflt "
                        appearance="primary"
                        onClick={filterAreas}
                      >
                        {t("SEARCH")}
                      </Button>
                      <Button
                        className="rs-btn-blue"
                        appearance="primary"
                        onClick={(e) => clearSearch()}
                      >
                        {t("CLEAR")}
                      </Button>
                    </React.Fragment>
                  ) : (
                    ""
                  )}
                  {showAdd ? (
                    <Button
                      className="rs-btn-green"
                      appearance="primary"
                      onClick={saveArea}
                    >
                      {t("SAVE")}
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    color="orange"
                    appearance="primary"
                    onClick={cancelAction}
                  >
                    {t("CANCEL")}
                  </Button>
                </div>
              </div>
            </Form>
          ) : (
            ""
          )}
          <Content>
            <Table
              loading={loading}
              height={400}
              fillHeight={true}
              data={areaData}
              hover={true}
              onSortColumn={onSortChange}
              sortColumn={sort_by}
              sortType={sort_order}
              bordered
              cellBordered
            >
              <Column fixed flexGrow={1} align="left" sortable>
                <CustomHeaderCell>{t("AREA")}</CustomHeaderCell>
                <CustomCell dataKey="area_name" />
              </Column>

              <Column flexGrow={1} align="center" sortable>
                <CustomHeaderCell>{t("PINCODE")}</CustomHeaderCell>
                <CustomCell dataKey="pincode" />
              </Column>
              <Column flexGrow={1} align="center" sortable>
                <CustomHeaderCell>
                  {t("AREA")} {t("TYPE")}
                </CustomHeaderCell>
                <CustomCell dataKey="area_type" />
              </Column>

              <Column flexGrow={1} align="center" sortable>
                <CustomHeaderCell>{t("CITY")}</CustomHeaderCell>
                <CustomCell dataKey="city_name" />
              </Column>

              <Column flexGrow={1} align="center">
                <CustomHeaderCell>{t("ACTION")}</CustomHeaderCell>
                <CustomCell>
                  {(rowData: any) => {
                    return (
                      <React.Fragment>
                        <a
                          href="javascript:void(0)"
                          onClick={() => editArea(rowData)}
                          title={t("EDIT")}
                        >
                          <EditIcon />
                        </a>
                        &nbsp;
                        <a
                          href="javascript:void(0)"
                          onClick={() => {
                            setOpenDeleteModal(true);
                            setSelectedAreaId(rowData.id);
                          }}
                          title={t("DELETE")}
                        >
                          <TrashIcon />
                        </a>
                      </React.Fragment>
                    );
                  }}
                </CustomCell>
              </Column>
            </Table>
          </Content>
          <Footer className="footer">
            <Pagination
              total={areaTotal}
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="xs"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              limitOptions={appConstObj.limit_options}
              limit={rows}
              activePage={page}
              onChangePage={onPageChange}
              onChangeLimit={handleChangeRows}
            />
          </Footer>
        </Panel>
      </Container>

      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            deleteArea(selectedAreaId);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("AREA").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("AREA").toLowerCase(),
        })}
      />
    </div>
  );
}

export default Areas;
